import styled, { css } from 'styled-components'

export const WrapperBox = styled.div`
	min-height: 88px;
	background-color: ${({ theme }) => theme.colors.background.element.veryLight};
	color: ${({ theme }) => theme.colors.content.veryDark};
	padding: 15px 50px;

	${({ theme }) => theme.breakpoints.up('md')} {
		padding: 15px 50px;
	}

	${({ theme }) => theme.breakpoints.down('md')} {
		padding: 15px 20px;
		padding-bottom: 20px;
	}

	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: center;
	gap: 10px;

	.get-started-text {
		font-family: 'Open Sans';
		font-style: normal;
		font-weight: 600;
		font-size: 16px;
		line-height: 20px;
		letter-spacing: 0.1px;
		width: 65%;
		${({ theme }) => theme.breakpoints.down('md')} {
			width: 100%;
		}
		${({ theme }) => theme.breakpoints.down('sm')} {
			font-size: 12px;
			padding-top: 5px;
		}

		color: ${({ theme }) => theme.colors.content.veryDark};
	}
`

export const getStartStyle = css`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 12px 12px;
	width: 158px;
	min-width: 158px;
	height: 48px;
	background: ${({ theme }) => theme.colors.primary.main};
	border-radius: 5px;
	border-color: ${({ theme }) => theme.colors.primary.main};

	text-transform: uppercase;
	color: ${({ theme }) => theme.colors.background.app.light};

	&:hover {
		color: ${({ theme }) => theme.colors.primary.main};
	}

	${({ theme }) => theme.breakpoints.down('sm')} {
		font-size: 14px;
		width: 100%;
		padding-bottom: 10px;
	}
`

export const refferStyle = css`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 12px 12px;
	width: 200px;
	min-width: 158px;
	height: 48px;
	margin-right: 16px;
	background: transparent;
	border-radius: 5px;
	border-width: 2px !important;
	border-color: ${({ theme }) => theme.colors.secondary.sub};
	text-transform: uppercase;
	color: ${({ theme }) => theme.colors.secondary.sub} !important;
	${({ theme }) => theme.breakpoints.down('sm')} {
		font-size: 14px;
		width: 100%;
		padding-bottom: 10px;
		color: ${({ theme }) => theme.colors.secondary.sub} !important;
	}
`
